import * as React from 'react';
import * as Cookies from 'js-cookie';
import * as firebase from 'firebase';
import {Link, withRouter} from 'react-router-dom';
import {compose} from 'recompose';

import {List, Spin} from 'antd';

import Firebase, {withFirebase} from '../../components/Firebase';
import {ICourse} from '../../model/Course';
import Constants from '../../constants';


interface IProps {
  match: any;
  firebase: Firebase;
}

interface IState {
  myCourses: ICourse[] | 'loading'
}

class MyCourses extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      myCourses: 'loading'
    }
  }

  componentDidMount(): void {
    const uid = Cookies.get(Constants.uid);
    if (!uid) {return;}

    this.props.firebase.getUser(uid)
      .then((doc: firebase.firestore.DocumentSnapshot) => {
        if (doc.exists) {
          // @ts-ignore since we know from firebase docs that doc.data() is not undefined if doc.exists
          // otherwise it will ts will argue on doc.data() being undefined
          this.setState(() => ({myCourses: doc.data().courses}))
        }
      })

  }

  public render() {
    const {myCourses} = this.state;
    const renderCourseItem = (course: string) => {
      return(
        <List.Item>
          <Link to={`${this.props.match.url}/${course}`}>{course}</Link>
        </List.Item>
      )
    };

    const content = (() => {
      if (myCourses === 'loading') {
        return <Spin size='large'/>
      }
      if (myCourses.length === 0) {
        return <h4>You haven't added courses yet</h4>
      }
      return <List dataSource={myCourses} renderItem={renderCourseItem}/>
    })();

    return(
      <div>
        <h4 className='list-header'>MY COURSES</h4>
        {content}
      </div>
    )
  }
}

export default compose(
  withRouter,
  withFirebase
)(MyCourses);